/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { zodResolver } from "@hookform/resolvers/zod"
import { t } from "i18next"
import { useForm } from "react-hook-form"
import { toast } from "sonner"
import { z } from "zod"

import { useAITranslatorSettingsLocal } from "./use-ai-translator-settings-local"
import { defaultSettings } from "../constants/translator-defaults"

export function useAddNewLanguage() {
  const { settings, updateSettings } = useAITranslatorSettingsLocal()

  const availableLanguages = settings.availableLanguages ?? defaultSettings.availableLanguages

  const formSchema = z.object({
    language: z
      .string()
      .min(1, { message: t("textinputdropdown.language_required") })
      .max(20),
  })

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      language: "",
    },
  })

  function onAddNewLanguage(values: z.infer<typeof formSchema>) {
    const languageAlreadyExists = availableLanguages
      .map((lang: string) => lang.toLowerCase())
      .includes(values.language.trim().toLowerCase())

    if (languageAlreadyExists) {
      form.setError("language", {
        type: "manual",
        message: t("textinputdropdown.language_already_exists"),
      })
      return
    }

    const newLanguage = values.language.trim()
    const capitalizedLanguage = newLanguage.charAt(0).toUpperCase() + newLanguage.slice(1)

    updateSettings({
      availableLanguages: [...availableLanguages, capitalizedLanguage],
      selectedLanguage: capitalizedLanguage,
    })

    form.reset()
    toast.success(`${capitalizedLanguage} ${t("textinputdropdown.language_added")}`)
  }

  return { form, onAddNewLanguage }
}
